export default __webpack_public_path__ + "static/1665-b26a3c2330e1d2274134827b77a73d1c.gif";